"use client";

import { useQuery } from "@tanstack/react-query";
import { useContext, useState, useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { personTitleSearchOptions } from "@/queryOptions/persons";
import { FilterParamsContext } from "@/stories/SearchDrawerComponents/FilterParamsProvider";

export default function SpeakerSelect() {
  const { filterParams, setFilterParams } = useContext(FilterParamsContext);
  const [inputValue, setInputValue] = useState("");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");

  const { data: titles, isLoading } = useQuery(
    personTitleSearchOptions(debouncedInputValue),
  );

  // Debounce the input value
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedInputValue(inputValue);
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [inputValue]);

  return (
    <Autocomplete
      multiple
      freeSolo
      options={
        titles
          ? [
              inputValue,
              ...(titles.result_examples.filter(
                (example) => example !== inputValue,
              ) ?? []),
            ]
          : []
      }
      value={filterParams.title_search_terms ?? []}
      onChange={(_event, newValue) => {
        setFilterParams({
          ...filterParams,
          title_search_terms: newValue,
        });
      }}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue, reason) => {
        // Only clear input when user explicitly clears it, not when selecting options
        if (reason !== "selectOption") {
          setInputValue(newInputValue);
        }
      }}
      getOptionLabel={(option) => {
        if (option === inputValue) {
          return `${option} - ${titles?.result_count} matching title${titles?.result_count === 1 ? "" : "s"}`;
        }
        return option;
      }}
      getOptionKey={(option) => option}
      renderInput={(params) => <TextField {...params} label="Title" />}
      loading={isLoading}
      disableCloseOnSelect
      clearOnBlur={false}
      filterOptions={(x) => x} // Disable built-in filtering since we're using API search
    />
  );
}
